[
  {
    "code" : "101",
    "name" : "Aegean Reg. of Shp."
  },
  {
    "code" : "1",
    "name" : "American Bur. of Shp."
  },
  {
    "code" : "102",
    "name" : "Asia Classif. Society"
  },
  {
    "code" : "103",
    "name" : "Bolivian Reg. of Shp."
  },
  {
    "code" : "4",
    "name" : "Bulgarian Reg. of Shp."
  },
  {
    "code" : "5",
    "name" : "Bureau Veritas"
  },
  {
    "code" : "108",
    "name" : "CR"
  },
  {
    "code" : "6",
    "name" : "China Classif. Society"
  },
  {
    "code" : "7",
    "name" : "China Corporation Reg. of Shp."
  },
  {
    "code" : "104",
    "name" : "Columbus American Register"
  },
  {
    "code" : "105",
    "name" : "Comp. Nacional De Registro De Naves"
  },
  {
    "code" : "106",
    "name" : "Conarina LLC"
  },
  {
    "code" : "107",
    "name" : "Cosmos Marine Bureau Inc."
  },
  {
    "code" : "8",
    "name" : "Croatian Reg. of Shp."
  },
  {
    "code" : "109",
    "name" : "Cyprus Bur. of Shp."
  },
  {
    "code" : "112",
    "name" : "DNV GL AS"
  },
  {
    "code" : "110",
    "name" : "Danforth"
  },
  {
    "code" : "111",
    "name" : "Det Norske Veritas"
  },
  {
    "code" : "113",
    "name" : "Dromon Bur. of Shp."
  },
  {
    "code" : "114",
    "name" : "Emirates Classif. Society"
  },
  {
    "code" : "115",
    "name" : "Foresight Ship Classif."
  },
  {
    "code" : "12",
    "name" : "Germanischer Lloyd"
  },
  {
    "code" : "116",
    "name" : "Guardian Bur. of Shp."
  },
  {
    "code" : "13",
    "name" : "Hellenic Reg. of Shp."
  },
  {
    "code" : "117",
    "name" : "Horizon"
  },
  {
    "code" : "118",
    "name" : "Icons Marine Services Pte Ltd"
  },
  {
    "code" : "14",
    "name" : "Indian Reg. of Shp."
  },
  {
    "code" : "119",
    "name" : "Inspeccion y Classif. Maritima"
  },
  {
    "code" : "120",
    "name" : "Int. Marine Survey Association"
  },
  {
    "code" : "121",
    "name" : "Int. Maritime Classif."
  },
  {
    "code" : "122",
    "name" : "Int. Maritime Register"
  },
  {
    "code" : "123",
    "name" : "Int. Naval Surveys Bureau"
  },
  {
    "code" : "124",
    "name" : "Int. Reg. of Shp."
  },
  {
    "code" : "125",
    "name" : "Int. Ship Classif."
  },
  {
    "code" : "126",
    "name" : "Intermaritime Cert. Services"
  },
  {
    "code" : "127",
    "name" : "Intertek Maritime Bureau"
  },
  {
    "code" : "128",
    "name" : "Iranian Classif. Society"
  },
  {
    "code" : "129",
    "name" : "Isthmus Bur. of Shp."
  },
  {
    "code" : "130",
    "name" : "Isthmus Maritime Classif. Society"
  },
  {
    "code" : "131",
    "name" : "Korea Classif. Society"
  },
  {
    "code" : "132",
    "name" : "Korea Ship Safety Technology Auth."
  },
  {
    "code" : "17",
    "name" : "Korean Reg. of Shp."
  },
  {
    "code" : "133",
    "name" : "Limdal Marine Services B.V."
  },
  {
    "code" : "20",
    "name" : "Lloyd's Register"
  },
  {
    "code" : "134",
    "name" : "M&P Surveyors, S. de R.L. de C.V."
  },
  {
    "code" : "135",
    "name" : "Macosnar Corporation"
  },
  {
    "code" : "136",
    "name" : "Maritime Bur. of Shp."
  },
  {
    "code" : "137",
    "name" : "Maritime Inspection Corporation"
  },
  {
    "code" : "138",
    "name" : "Maritime Lloyd"
  },
  {
    "code" : "139",
    "name" : "Maritime Technical Syst. and Serv."
  },
  {
    "code" : "140",
    "name" : "Mediterranean Shipping Register"
  },
  {
    "code" : "141",
    "name" : "National Shipping Adjuster Inc."
  },
  {
    "code" : "142",
    "name" : "New United Int. Marine Services"
  },
  {
    "code" : "143",
    "name" : "New United Marine Services LT"
  },
  {
    "code" : "26",
    "name" : "Nippon Kaiji Kyokai"
  },
  {
    "code" : "144",
    "name" : "Novel Classif. Society S.A."
  },
  {
    "code" : "80",
    "name" : "Other"
  },
  {
    "code" : "145",
    "name" : "Overseas Marine Cert. Services"
  },
  {
    "code" : "3",
    "name" : "PT Biro Klasifikasi Indonesia"
  },
  {
    "code" : "29",
    "name" : "Panama Bur. of Shp."
  },
  {
    "code" : "146",
    "name" : "Panama Maritime Doc. Services"
  },
  {
    "code" : "147",
    "name" : "Panama Shipping Registrar Inc."
  },
  {
    "code" : "148",
    "name" : "Phoenix Reg. of Shp. S.A."
  },
  {
    "code" : "30",
    "name" : "Polish Reg. of Shp."
  },
  {
    "code" : "151",
    "name" : "RINA Services S.p.A"
  },
  {
    "code" : "43",
    "name" : "RINA Services SPA"
  },
  {
    "code" : "149",
    "name" : "Registro Brasileiro de Navios LTDA"
  },
  {
    "code" : "31",
    "name" : "Registro Cubano de Buques"
  },
  {
    "code" : "150",
    "name" : "Registrul Naval Republic of Moldova"
  },
  {
    "code" : "152",
    "name" : "Rinave Portuguesa"
  },
  {
    "code" : "22",
    "name" : "Russian Maritime Reg. of Shp."
  },
  {
    "code" : "36",
    "name" : "Russian River Register"
  },
  {
    "code" : "153",
    "name" : "SAC Register"
  },
  {
    "code" : "154",
    "name" : "Ship Classif. Malaysia"
  },
  {
    "code" : "37",
    "name" : "Shipping Register of Ukraine"
  },
  {
    "code" : "155",
    "name" : "Sing Lloyd"
  },
  {
    "code" : "156",
    "name" : "SingClass Int."
  },
  {
    "code" : "157",
    "name" : "Togo Bur. Of Shp."
  },
  {
    "code" : "38",
    "name" : "Turkish Lloyd"
  },
  {
    "code" : "158",
    "name" : "Union Bur. of Shp."
  },
  {
    "code" : "159",
    "name" : "United Reg. and Classif. of Service"
  },
  {
    "code" : "160",
    "name" : "Universal Maritime Bureau Ltd"
  },
  {
    "code" : "161",
    "name" : "Universal Shipping Bureau Inc."
  },
  {
    "code" : "162",
    "name" : "Vega Register Inc."
  },
  {
    "code" : "163",
    "name" : "Venezuelan Reg. of Shp."
  },
  {
    "code" : "40",
    "name" : "Vietnam Register"
  },
  {
    "code" : "164",
    "name" : "Vira Shipping Inc."
  },
  {
    "code" : "15",
    "name" : "Yugoslav Reg. of Shp."
  }
]
